import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowDownTray = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.5 7.83333V10.1667C11.5 10.903 10.903 11.5 10.1667 11.5H1.83333C1.09695 11.5 0.5 10.903 0.5 10.1667V7.83333M5.99999 8V0.5M8.33333 5.66667L5.99999 8L3.66667 5.66667"
    />
  </svg>
);
export default SvgArrowDownTray;
